import React, { memo, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import Rating from '@prisjakt/ui-rating';
import RatingHelper from '@prisjakt/ui-rating/src/rating-helper';
import { StarIcon } from '@prisjakt/ui-icons';

import * as S from './styles';

const SCALE = 5;

type Props = {
  className?: string;
  rating: number;
  count: number;
  distribution: number[];
};

const ReviewsSummary = ({ className, rating, count, distribution }: Props) => {
  const { t } = useContext(AppContext);

  if (!rating || !count || !distribution) return null;

  return (
    <S.SummaryWrapper className={className}>
      <S.Summary>
        <S.Score>
          <S.Value>{RatingHelper.toRounded(rating)}</S.Value> / {SCALE}
        </S.Score>
        <S.RatingWrapper>
          <Rating
            size="large"
            rate={rating}
            count={count}
            showCounter={false}
          />
          {`(${t('reviews', 'rating.n-reviews', { n: count })})`}
        </S.RatingWrapper>
      </S.Summary>

      {distribution && count >= SCALE && (
        <S.Distribution>
          {distribution.map((ratingCount, index) => {
            const rate = SCALE - index;
            const ratio = Math.round((ratingCount / count) * 100);

            return (
              <React.Fragment key={index.toString()}>
                <S.MeterLabel>
                  {rate} <StarIcon height={12} styling="active" />
                </S.MeterLabel>
                <S.Meter>
                  <S.Indicator width={`${ratio}%`} />
                </S.Meter>
                <S.MeterLabel>({ratingCount})</S.MeterLabel>
              </React.Fragment>
            );
          })}
        </S.Distribution>
      )}
    </S.SummaryWrapper>
  );
};

export default memo(ReviewsSummary);
